import React, {useState} from 'react';
import {Input, Modal} from 'antd';
import {ExclamationCircleFilled} from '@ant-design/icons';
import DefaultCommentSuggestions from "../DefaultCommentSuggestions";

const {TextArea} = Input;

const ValidationAttestationModal = ({visible, lotA, statutCommande, onOk, onCancel, actionVerb, loading}) => {
    const [updateCommentaire, setUpdateCommentaire] = useState('');

    const handleOk = () => {
        // Trigger the onOk callback with the lot and comment text
        onOk(lotA, updateCommentaire);
    };

    const getSuccessor = (statutCommande) => {
        switch (statutCommande) {
            case "INITIE":
                return "VALIDE";
            case "VALIDE":
                return "AUTORISE";
            case "AUTORISE":
                return "CONFIRME";
            case "EN_TRAITEMENT":
                return "APPROUVE";
            case "APPROUVE":
                return "REGLE";
            case "APPROUVE":
                return "DELIVRE";
            case "CONFIRME":
                return "DELIVRE";
            case "DELIVRE":
                return "RECEPTIONNE";
            case "RECEPTIONNE":
                return "volcano";
            default:
                return "default";
        }
    };
    console.log(updateCommentaire)

    return (
        <Modal
            visible={visible}
            title={`Êtes-vous sûr de vouloir ${actionVerb} la commande ?`}
            icon={<ExclamationCircleFilled style={{color: "#1890ff", fontSize: "24px"}}/>}
            width={700}
            onCancel={onCancel}
            onOk={handleOk}
            okText="Oui"
            cancelText="Annuler"
            loading={loading}
            confirmLoading={loading}
        >
            <div style={{padding: "1rem"}}>
                <p style={{color: "#faad14", marginBottom: "1rem", fontSize: "16px", fontWeight: 500}}>
                    Toutes vos actions sont historisées.
                </p>
                <div style={{marginBottom: "1rem"}}>
                    <label
                        htmlFor="commentaire"
                        style={{
                            display: "block",
                            marginBottom: "0.5rem",
                            fontWeight: 600,
                            fontSize: "15px"
                        }}
                    >
                        Faites un commentaire :
                    </label>
                    <TextArea
                        id="commentaire"
                        rows={3}
                        value={updateCommentaire}
                        onChange={(e) => setUpdateCommentaire(e.target.value)}
                        placeholder="Votre commentaire ici ..."
                        style={{
                            borderRadius: "8px",
                            padding: "10px",
                            border: "1px solid #d9d9d9",
                            width: "100%",
                            fontSize: "14px",
                            boxSizing: "border-box"
                        }}
                    />
                    <div style={{marginTop: "12px"}}>
                        <DefaultCommentSuggestions
                            statutCommande={getSuccessor(statutCommande)}
                            onSelect={setUpdateCommentaire}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ValidationAttestationModal;
